import React from 'react';
import { SVGProps } from './SVGProps';

/**
 * UnifiedAR SVG
 *
 * @returns
 */
function UnifiedARSVG({ className }: SVGProps) {
	return <img className={className} src="/images/ar-logo.png" alt="AR Logo" />;
}

export default UnifiedARSVG;
